import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,BulkEdit,AddListItem,
        DynamicListArea,DownloadTemplate,LoadGraphic,Step,Segment,
        SegmentComplete,DataboxGeneral} from '../components/Common';
import {Button,Box,EditSizeLabel,EditSizeLink,TextButton,
        ContactNumber,Checkbox,ImageThumbnail,EditableBox,Info,
        Select,EditableArea} from '../components/Input';
import {AddAssignment} from './Client';
import u from '../utilities/Utilities';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Link} from 'react-router-dom';
import store from 'store';

export default class HOTOList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Handover/Takeover",
        permission:"hoto",
        url:"/hoto-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-hoto-entry",
        //bulkURL:"/api/add-bulk-client",
        deleteURL:"/api/delete-hoto-entries",
        spreadsheetURL:"/api/generate-hoto-spreadsheet",
        //templateURL:"/api/get-add-client-template",
        overviewURL:"/api/get-all-hoto-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"hoto-list",
        orderByField:"handoverOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    }

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        addError:"",
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("hoto");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
              {label:"Add Draft Entry",ref:"add",enabled:(permissions.create==2)},
              {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
              {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
              {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
              {label:"Setup Hoto Items",ref:"setup",enabled:(permissions.create==2),onClick:this.onHotoItems},
            ],
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    onHotoItems=()=>{
        window.location="/hoto-item-list"
    }

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu settings={this.settings}
                          buttons={this.state.pageMenuButtons}
                          components={this.pageComponents}
                          selected={this.state.selected}/>

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <HOTOItem key={index}
                                          content={content}
                                          index={index}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          settings={this.settings}
                                          permissions={this.state.permissions}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

export class HOTOItem extends React.Component{

    state={
        step:"view-handover",
        loading:false,
        loadText:""
    }

    static getDamageAmount(item,content){
        const toDamageList=HOTOItem.getDamageList(content);
        let damages = 0.0;
        for(var i=0; i<toDamageList.length; i++){
            const d = toDamageList[i];
            if(d.hotoItemID == item.hotoItemID){
                damages += HOTOItem.calculateDamages(d);
            }
        }
        return "$"+damages.toFixed(2);
    }

    componentDidMount=()=>{
        if(this.props.content.estateStatus == "Taken Over"){
            this.setState({step:"view-takeover"})
        }
    }

    onAddInventory=()=>{

    }

    onAddPhoto=()=>{

    }

    onViewPhoto=(list,index,subIndex)=>{
        this.setState({error:""});
        const content=this.props.content;
        console.log(list,index,subIndex);
        let image=0;
        if(typeof subIndex != "undefined"){
            image = content[list][index].photos[subIndex];
        }
        else{
            image=content[list][index];
        }
        if(image){
            window.open(image,"__blank");
        }
        else{
            this.setState({error:"Image Not Found"});
        }
    }

    onDeletePhoto=()=>{

    }

    onChangeDamage=(value,label,index)=>{
        let toInventory=this.props.content.toInventory;
        for(var i=0; i<toInventory.length; i++){
            if(toInventory[i].hotoItemID == index.hotoItemID){
                const damages=toInventory[i].damages;
                for(var j=0; j<damages.length; j++){
                    if(damages[j].damageID == index.damageID){
                        damages[j][label]=value;
                    }
                }
            }
        }
        this.props.onChange(toInventory,"toInventory",this.props.index);
    }

    onViewReport=(type)=>{
        if(type == "handover"){
            store.set("handover-report",[this.props.content]);
            window.open("handover-report","__blank");
        }
        else if(type == "takeover"){
            store.set("takeover-report",[this.props.content]);
            window.open("takeover-report","__blank");
        }
    }

    static calculateDamages(item){
        let quantity = (parseInt(item.quantity) - parseInt((item.waive) ? item.waive : "0"));
        return (quantity >= 0 ? quantity : 0) * parseFloat(item.amount);
    }

    static getDamageList(content){
        let toDamageList=[];
        const toInventory=content.toInventory;
        for(var i=0; i<toInventory.length; i++){
            const damages=toInventory[i].damages.map(
                (item)=>{
                    item.hotoItemID = toInventory[i].hotoItemID;
                    item.itemName=toInventory[i].itemName;
                    return item;
                }
            )
            toDamageList = toDamageList.concat(damages);
        }
        return toDamageList;
    }

    render=()=>{
        const content = this.props.content;
        const permissions=this.props.permissions;
        const toDamageList = HOTOItem.getDamageList(content);

        return (
            <div style={{position:"relative",textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <DynamicListArea listLabel={"hoto-list"}
                                 permission={this.props.settings.permission}
                                 content={this.props.content}
                                 onChange={this.props.onChange}
                                 index={this.props.index}
                                 />

                <Step active={(this.state.step=="view-handover")}>
                    <div>
                    <h3 style={{marginBottom:"0"}}>Handover Inventory</h3>

                    {
                        (content.hoInventory.length > 0)
                            ?
                            <div className="list-table ho-inventory-container" style={{maxHeight:"none"}}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="hoto-sn">S/N</th>
                                            <th>Item</th>
                                            <th className="hoto-quantity">Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            content.hoInventory.map(
                                                (item,index)=>{
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index+1}.</td>
                                                            <td><HandoverItem item={item}/></td>
                                                            <td className="hoto-quantity">{item.hoQuantity}</td>
                                                        </tr>
                                                    )
                                                }
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="list-placeholder">
                                <h3>No Inventory Handed Over</h3>
                            </div>
                    }

                    {
                        (content.estateStatus == "Handover Draft")
                            ?
                            <div className="text-negative" style={{margin:"20px auto"}}>
                                <b>Draft entry - Use Smartdorm Mobile App to complete the handover</b>
                            </div>
                            :
                            <div>
                              {
                                  (content.hoPhotos.length > 0)
                                    ?
                                    <div className="hoto-main-image-container">
                                        <h3>Handover Photos</h3>
                                        {
                                            content.hoPhotos.map(
                                                (item,index)=>{
                                                    return (
                                                      <ImageThumbnail key={index}
                                                                      src={item}
                                                                      style={{margin:"10px"}}
                                                                      />
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                    :
                                    <div className="hoto-main-placeholder">No Handover Photos</div>
                              }

                              <div style={{margin:"20px auto"}}>
                                  <Button onClick={()=>{this.onViewReport("handover")}}>Handover Report</Button>
                              </div>

                              {
                                  (this.state.showChange)
                                      ?
                                      <div className="list-table ho-inventory-container" style={{maxHeight:"none"}}>
                                          <h3>Change Log</h3>
                                          {
                                              (content.changeLog.length > 0)
                                                  ?
                                                  <table>
                                                      <thead>
                                                          <tr>
                                                              <th className="hoto-date">Date</th>
                                                              <th>Change</th>
                                                              <th className="hoto-staff">Handover By</th>
                                                              <th className="hoto-staff">Verified By</th>
                                                          </tr>
                                                      </thead>
                                                      <tbody>
                                                          {
                                                              content.changeLog.map(
                                                                  (item,index)=>{
                                                                      return (
                                                                          <tr key={index}>
                                                                              <td>{moment(item.dateTime).format("DD MMM YY")}</td>
                                                                              <td>{item.label}</td>
                                                                              <td>{item.staffName}</td>
                                                                              <td>
                                                                                  {
                                                                                      (item.verifiedBySign)
                                                                                        ?
                                                                                        <Info image={item.verifiedBySign}
                                                                                              ignoreOffset={true}
                                                                                              style={{width:"auto",height:"auto",marginBottom:"0"}}>
                                                                                            {item.verifiedByName}
                                                                                        </Info>
                                                                                        :
                                                                                        "None"
                                                                                  }
                                                                              </td>
                                                                          </tr>
                                                                      )
                                                                  }
                                                              )
                                                          }
                                                      </tbody>
                                                  </table>
                                                  :
                                                  <div className="list-placeholder">
                                                      <b>No Inventory Changes</b>
                                                  </div>
                                          }
                                      </div>
                                      :
                                      null
                              }

                              <div style={{margin:"20px auto"}}>
                                  <TextButton onClick={()=>{this.setState({showChange:!this.state.showChange})}}>
                                      {
                                          (this.state.showChange)
                                              ?
                                              "Hide Change Log"
                                              :
                                              "See Change Log"
                                      }
                                  </TextButton>

                                  {
                                      (content.estateStatus == "Taken Over")
                                          ?
                                          <TextButton onClick={()=>{this.setState({step:"view-takeover",error:""})}}>See Takeover</TextButton>
                                          :
                                          null
                                  }
                              </div>
                            </div>
                    }
                    </div>
                </Step>

                <Step active={(this.state.step=="view-takeover")}>

                    <h3 style={{marginBottom:"0"}}>Takeover Inventory</h3>

                    {
                        (content.toInventory.length > 0)
                            ?
                            <div className="list-table ho-inventory-container" style={{maxHeight:"none"}}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="hoto-sn"/>
                                            <th>Item</th>
                                            <th className="hoto-quantity">Handover</th>
                                            <th className="hoto-quantity">Takeover</th>
                                            <th className="hoto-amount">Damages</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            content.toInventory.map(
                                                (item,index)=>{
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index+1}.</td>
                                                            <td>{item.itemName}</td>
                                                            <td className="hoto-quantity">{item.hoQuantity}</td>
                                                            <td className="hoto-quantity">{item.toQuantity}</td>
                                                            <td className="hoto-amount">{HOTOItem.getDamageAmount(item,content)}</td>
                                                        </tr>
                                                    )
                                                }
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="list-placeholder">
                                <h3>No Inventory Taken Over</h3>
                            </div>
                    }

                    {
                        (content.toPhotos.length > 0)
                          ?
                          <div className="hoto-main-image-container">
                              <h3>Takeover Photos</h3>
                              {
                                  content.toPhotos.map(
                                      (item,index)=>{
                                          return (
                                            <ImageThumbnail key={index}
                                                            src={item}
                                                            style={{margin:"10px"}}
                                                            />
                                          )
                                      }
                                  )
                              }
                          </div>
                          :
                          <div className="hoto-main-placeholder">No Takeover Photos</div>
                    }

                    <div style={{margin:"20px auto"}}>
                        <Button onClick={()=>{this.onViewReport("takeover")}}>Takeover Report</Button>
                    </div>

                    {
                        (this.state.showDamages)
                            ?
                            <div className="list-table ho-inventory-container" style={{maxHeight:"none"}}>
                                <h3 style={{marginBottom:"0"}}>Damage List</h3>
                                {
                                    (toDamageList.length > 0)
                                        ?
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="hoto-sn">S/N</th>
                                                    <th className="hoto-item">Damage</th>
                                                    <th className="hoto-quantity">Quantity</th>
                                                    <th className="hoto-quantity">Waive</th>
                                                    <th className="hoto-amount">Amount</th>
                                                    <th className="hoto-amount">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    toDamageList.map(
                                                        (item,index)=>{
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="hoto-sn">{index + 1}.</td>
                                                                    <td className="hoto-item">
                                                                        {item.itemName} - {item.label}
                                                                        <div className="hoto-image-container">
                                                                            {
                                                                                item.photo.map(
                                                                                    (url,p)=>{
                                                                                        return (
                                                                                            <ImageThumbnail key={p}
                                                                                                            width="30px"
                                                                                                            height="30px"
                                                                                                            style={{
                                                                                                              margin:"0 3px",
                                                                                                              marginLeft:(p==0) ? "0" : undefined
                                                                                                            }}
                                                                                                            src={url}
                                                                                                            />
                                                                                        )
                                                                                    }
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="hoto-quantity">{item.quantity}</td>
                                                                    <td className="hoto-waive">
                                                                        <EditableBox label="Waive"
                                                                                     index={{hotoItemID:item.hotoItemID,damageID:item.damageID}}
                                                                                     values={{value:item.waive,enabled:(permissions.update)}}
                                                                                     type="number"
                                                                                     field="waive"
                                                                                     rules={{minValue:0,nullText:"0",maxValue:item.quantity}}
                                                                                     url="/api/update-hoto-damage-waive"
                                                                                     id={{
                                                                                       hotoID:content.hotoID,
                                                                                       entry:item
                                                                                     }}
                                                                                     onChange={this.onChangeDamage}
                                                                                     />
                                                                    </td>
                                                                    <td className="hoto-amount">${parseFloat(item.amount).toFixed(2)}</td>
                                                                    <td className="hoto-amount">${(HOTOItem.calculateDamages(item)).toFixed(2)}</td>
                                                                </tr>
                                                            )
                                                        }
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                        :
                                        <div className="list-placeholder">
                                            <b>No Damages</b>
                                        </div>
                                }
                            </div>
                            :
                            null
                    }

                    <div style={{margin:"20px auto"}}>
                        <TextButton onClick={()=>{this.setState({showDamages:!this.state.showDamages})}}>
                            {
                                (this.state.showDamages)
                                    ?
                                    "Hide Damages"
                                    :
                                    "See Damages"
                            }
                        </TextButton>
                        <TextButton onClick={()=>{this.setState({step:"view-handover",error:""})}}>See Handover</TextButton>
                    </div>
                </Step>
            </div>
        )
    }
}

class HandoverItem extends React.Component{

  state={
      showDetail:false
  }

  onClick=()=>{
      this.setState({showDetail:!this.state.showDetail});
  }

  getDetails=(content)=>{
    let hasDefects = false;
    let hasRectifications = false;

    for(var i=0; i<content.defects.length; i++){
        let d = content.defects[i];
        if(d.defectQuantity > 0){
            hasDefects=true;
        }
        if(d.resolveQuantity > 0){
            hasRectifications=true;
        }

        if(hasDefects && hasRectifications){
           break;
        }
    }

    return{
        hasDefects:hasDefects,
        hasRectifications:hasRectifications,
    }
  }

  render=()=>{
     const item=this.props.item;
     const details = this.getDetails(item);

     return (
        <div className="handover-item-entry">
          <div className={"handover-item-name" + (details.hasDefects ? " defect" : "")} onClick={(details.hasDefects) ? this.onClick : undefined}>
            {item.itemName}
            {
                (item.defects.length > 0)
                    ?
                    <span> ({item.defects.length} Defects)</span>
                    :
                    null
            }
          </div>

          {
              (this.state.showDetail)
                  ?
                  <div className="item-defects-container">
                      <div className="item-defects"><b>Defects</b></div>

                      {
                          (item.defects.length > 0)
                              ?
                              <ol className="hoto-remarks">
                                {
                                  item.defects.map(
                                      (defect,d)=>{
                                          return (
                                            <li key={d}>
                                                {
                                                    (defect.resolveQuantity > 0)
                                                        ?
                                                        <span className="resolve-quantity text-emphasis" style={{marginRight:"2px"}}>
                                                          <Info title={defect.defectQuantity + " instances of defects were identified at handover, " + defect.resolveQuantity + " instances have since been rectified"}
                                                                style={{width:"auto",height:"auto",marginBottom:"0"}}
                                                                ignoreOffset={true}>
                                                            {parseInt(defect.defectQuantity) - parseInt(defect.resolveQuantity)}
                                                          </Info>
                                                        </span>
                                                        :
                                                        null
                                                }
                                                <span className={"defect-quantity" + ((defect.resolveQuantity > 0) ? " resolved" : "")}>{defect.defectQuantity}</span>
                                                <span> x {defect.label}</span>
                                            </li>
                                          )
                                      }
                                  )
                                }
                              </ol>
                              :
                              null
                      }

                      <div className="hoto-image-container">
                      {
                          item.defects.map(
                              (defect,d)=>{
                                  return defect.defectPhoto.map(
                                      (photo,p)=>{
                                          return (
                                              <Info key={p} title={(d+1)+". " + defect.label} style={{width:"auto",height:"auto",marginBottom:"0"}}>
                                                  <ImageThumbnail key={p}
                                                                  src={photo}
                                                                  width="30px"
                                                                  height="30px"
                                                                  style={{
                                                                    margin:"0 3px",
                                                                    marginLeft:(p==0) ? "10px" : undefined
                                                                  }}
                                                                  />
                                              </Info>
                                          )
                                      }
                                  )
                              }
                          )
                      }
                      </div>

                      {
                          (details.hasRectifications)
                              ?
                              <div className="rectification-container">
                                  <div className="item-defects" style={{margin:"20px auto 15px auto"}}><b>Rectifications</b></div>
                                  <div className="hoto-image-container">
                                  {
                                      item.defects.map(
                                          (defect,d)=>{
                                              return defect.resolvePhoto.map(
                                                  (photo,p)=>{
                                                      return (
                                                          <Info key={p} title={(d+1)+". " + defect.label} style={{width:"auto",height:"auto",marginBottom:"0"}}>
                                                              <ImageThumbnail key={p}
                                                                              src={photo}
                                                                              width="30px"
                                                                              height="30px"
                                                                              style={{
                                                                                margin:"0 3px",
                                                                                marginLeft:(p==0) ? "10px" : undefined
                                                                              }}
                                                                              title={(d+1)+". " + defect.label}
                                                                              />
                                                          </Info>
                                                      )
                                                  }
                                              )
                                          }
                                      )
                                  }
                                  </div>
                              </div>
                              :
                              null
                      }
                  </div>
                  :
                  null
          }
        </div>
     )
  }
}

class AddEntry extends React.Component{

    state={
        step:"create",
        error:"",
        clientOptions:[{value:"None",label:"None"}],
        agreementOptions:[{value:"None",label:"None"}],
        dormOptions:[{value:"None",label:"None"}],
        staffOptions:[{value:"None",label:"None"}],
        entryData:{
          locations:[],
        },
        tempInventory:[],
    };

    componentDidMount=()=>{
        this.getDormOptions();
        this.getClientOptions();
        this.getStaffOptions();
    }

    onChangeClient=(clientID)=>{
        this.onChange(clientID,"clientID");
        this.getAgreementOptions(clientID);
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:"dorm"
            },
            success:(options)=>{
                this.setState({dormOptions:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        })
    }

    getClientOptions=()=>{
        u.post({
            url:"/api/get-client-options",
            data:{},
            success:(clientOptions)=>{
                clientOptions.unshift({value:"None",label:"None"});
                this.setState({clientOptions:clientOptions});
            }
        })
    }

    getAgreementOptions=(clientID)=>{
        let entryData=this.state.entryData;
        entryData.clientID=clientID;
        this.setState({
            entryData:entryData,
            agreementOptions:[{value:"None",label:"None"}],
        })
        if(clientID == "None"){
           return 0;
        }
        u.post({
            url:"/api/get-agreement-options",
            data:{
              additional:clientID
            },
            success:(agreementOptions)=>{
                agreementOptions.unshift({value:"None",label:"None"});
                this.setState({agreementOptions:agreementOptions});
            }
        })
    }

    getStaffOptions=()=>{
        u.post({
            url:"/api/get-staff-options",
            data:{},
            success:(staffOptions)=>{
                staffOptions.unshift({value:"None",label:"None"});
                this.setState({staffOptions:staffOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        })
    }

    onChange=(value,label,index)=>{
        let entryData=this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onLocation=()=>{
        let keys=['dormID',"clientID","agreementID","assignedPrimaryID","assignedSecondaryID"];
        for(var i=0; i<keys.length; i++){
            const current=this.refs[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }
        this.setState({loading:true,loadText:"Finding assignments..."});
        const entryData=this.state.entryData;
        u.post({
            url:"/api/get-hoto-location-options",
            data:{
                dormID:entryData.dormID,
                clientID:entryData.clientID,
                agreementID:entryData.agreementID,
            },
            success:(locations)=>{
                if(locations.length > 0){
                    entryData.locations=locations;
                    this.setState({entryData:entryData,step:"estate",error:""});
                }
                else{
                    this.setState({error:"No locations assigned to this client and/or agreement",loading:false});
                }
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onChangeLocation=(value,label,index)=>{
      let entryData=this.state.entryData;
      entryData.locations[index][label]=value;
      this.setState({
        entryData:entryData,
        bypass:false,
      });
    }

    show=(show)=>{
        this.refs['add'].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    onCancel=()=>{
        this.props.settings.onToggleForm(this.props.reference,false);
    }

    onSelectAll=(value)=>{
        let entryData=this.state.entryData;
        entryData.locations = entryData.locations.map(
            (item)=>{
                item.selected=value;
                return item;
            }
        )
        this.setState({
          entryData:entryData,
          bypass:false
        });
    }

    onEditInventory=(index)=>{
        const entry = this.state.entryData.locations[index];
        const tempInventory = JSON.parse(JSON.stringify(entry.hoInventory));
        const tempIndex=index;
        const tempEstateLabel=entry.estateLabel;
        this.setState({
            tempInventory:tempInventory,
            tempIndex:index,
            tempEstateLabel:entry.estateLabel,
            error:"",
            step:"inventory",
        });
    }

    onApplyInventory=()=>{
        for(var i=0; i<this.state.tempInventory.length; i++){
            const current=this.refs['quantity-'+i].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }
        let entryData=this.state.entryData;
        entryData.locations[this.state.tempIndex].hoInventory=this.state.tempInventory;
        this.setState({entryData:entryData,error:"",step:"estate"});
    }

    onChangeInventoryQuantity=(value,label,index)=>{
        let tempInventory=this.state.tempInventory;
        tempInventory[index][label]=value;
        this.setState({tempInventory:tempInventory});
    }

    onSubmit=()=>{
       const selected = this.state.entryData.locations.filter((item)=>{
          return item.selected;
       });

       const hasStatus = selected.filter(
          (item)=>{
              return (typeof item.status != "undefined");
          }
       );

       if(selected.length == 0){
          this.setState({error:"Select at least 1 estate to create a handover draft"});
          return 0;
       }

       if(hasStatus.length > 0 && !this.state.bypass){
          this.setState({
            error:"Selected "+hasStatus.length+" estate(s) that have outstanding HOTO entries, click create again to confirm new draft",
            bypass:true
          });
          return 0;
       }

       const entryData=this.state.entryData;
       this.refs[this.props.reference].onValidated({
          ...entryData,
          locations:selected,
       });
    }

    onComplete=()=>{
        this.setState({
            step:"create",
            entryData:{
              locations:[],
            },
            tempInventory:[],
            bypass:false
        })
    }

    render=()=>{
        let entryData=this.state.entryData;
        const estateOptions=this.state.estateOptions;
        const selectAll = entryData.locations.filter(
          (item,index)=>{
              return item.selected
          }).length == entryData.locations.length;

        return(
            <AddListItem ref={this.props.reference}
                         reference={this.props.reference}
                         settings={this.props.settings}
                         onComplete={this.onComplete}
                         onToggleForm={this.props.onToggleForm}>

                <Step active={this.state.step=="create"}>
                    <h3>Select the property to create handover draft</h3>

                    <div className="segment-error">{this.state.error}</div>

                    <div className="segment-content">
                        <div className="segment-full-item">
                            <div className="segment-item-label">Dormitory</div>
                            <div className="segment-item-input">
                                <Select ref="dormID"
                                        field="dormID"
                                        label="Dormitory"
                                        values={{
                                          value:entryData.dormID,
                                          options:this.state.dormOptions
                                        }}
                                        onChange={this.onChange}
                                        />
                            </div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Client <Info title={"Selected room/bed must be assigned to the client or an agreement associated with the respective client to create draft"}/></div>
                            <div className="segment-item-input">
                                <Select ref="clientID"
                                        field="clientID"
                                        label="Client"
                                        values={{
                                          value:entryData.clientID,
                                          options:this.state.clientOptions
                                        }}
                                        rules={{required:true}}
                                        onChange={this.onChangeClient}
                                        />
                            </div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Agreement <Info title={"<b>Optional</b><br/><br/> Selected room/bed must be assigned to the respective agreement to create drafts"}/></div>
                            <div className="segment-item-input">
                                <Select ref="agreementID"
                                        field="agreementID"
                                        label="Agreement"
                                        values={{
                                          value:entryData.agreementID,
                                          options:this.state.agreementOptions
                                        }}
                                        onChange={this.onChange}
                                        />
                            </div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Primary <Info title={"Entries will only be displayed on Smartdorm Mobile App when the user is assigned as primary or secondary"}/></div>
                            <div className="segment-item-input">
                                <Select ref="assignedPrimaryID"
                                        field="assignedPrimaryID"
                                        label="Assigned Primary"
                                        values={{
                                          value:entryData.assignedPrimaryID,
                                          options:this.state.staffOptions,
                                        }}
                                        onChange={this.onChange}
                                        />
                            </div>
                        </div>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Secondary <Info title={"Entries will only be displayed on Smartdorm Mobile App when the user is assigned as primary or secondary"}/></div>
                            <div className="segment-item-input">
                                <Select ref="assignedSecondaryID"
                                        field="assignedSecondaryID"
                                        label="Assigned Secondary"
                                        values={{
                                          value:entryData.assignedSecondaryID,
                                          options:this.state.staffOptions
                                        }}
                                        onChange={this.onChange}
                                        />
                            </div>
                        </div>

                        <div className="segment-buttons">
                            <span className="mobile-only"><Button onClick={this.onCancel}>Cancel</Button></span>
                            <Button type="medium" onClick={this.onLocation}>Create</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="estate"}>
                    <h3>Select the estates to create a draft</h3>

                    <div className="segment-table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="hoto-add-select">
                                        <Checkbox values={{value:selectAll}}
                                                  label="Select All"
                                                  onChange={this.onSelectAll}
                                                  />
                                    </th>
                                    <th className="hoto-add-status">Current</th>
                                    <th className="hoto-add-type">Type</th>
                                    <th className="hoto-add-beds">Beds</th>
                                    <th className="hoto-add-item">Location</th>
                                    <th className="hoto-add-inventory">Inventory</th>
                                </tr>
                            </thead>
                            <tbody style={{maxHeight:"430px"}}>
                                {
                                    entryData.locations.map(
                                        (item,index)=>{
                                            return (
                                                <tr className="item" key={index}>
                                                    <td className="hoto-add-select">
                                                        <Checkbox values={{value:item.selected}}
                                                                  field="selected"
                                                                  index={index}
                                                                  onChange={this.onChangeLocation}
                                                                  />
                                                    </td>
                                                    <td className="hoto-add-status">
                                                        {
                                                          (item.status)
                                                              ?
                                                              <Link style={{color:"#ff0000"}} to={"/hoto-list?tags=@id("+item.hotoID+")"} target="__blank">{item.status}</Link>
                                                              :
                                                              "-"
                                                        }
                                                    </td>
                                                    <td className="hoto-add-type">{item.estateType}</td>
                                                    <td className="hoto-add-beds">{item.bedCount}</td>
                                                    <td className="hoto-add-item">{item.estateLabel}</td>
                                                    <td className="hoto-add-inventory">
                                                        <TextButton onClick={()=>{this.onEditInventory(index)}}>Edit</TextButton>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    )
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="segment-buttons">
                        <div className="segment-error">{this.state.error}</div>
                        <Button onClick={()=>{this.setState({step:"create",errror:""})}}>Back</Button>
                        <Button onClick={this.onSubmit}>Create</Button>
                    </div>
                </Step>

                <Step active={this.state.step=="inventory"}>
                    <h3>Inventory for {this.state.tempEstateLabel}</h3>

                    <div className="segment-table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="hoto-add-sn"/>
                                    <th className="hoto-add-item">Item</th>
                                    <th className="hoto-add-quantity">Quantity</th>
                                </tr>
                            </thead>
                            <tbody style={{maxHeight:"430px"}}>
                                {
                                    this.state.tempInventory.map(
                                        (item,index)=>{
                                            return (
                                                <tr className="item" key={index}>
                                                    <td className="hoto-add-select">{index+1}.</td>
                                                    <td className="hoto-add-item">{item.itemName}</td>
                                                    <td className="hoto-add-quantity">
                                                        <Box ref={"quantity-"+index}
                                                             values={{value:item.hoQuantity}}
                                                             rules={{required:true,minValue:0}}
                                                             type="number"
                                                             index={index}
                                                             label="Quantity"
                                                             field="hoQuantity"
                                                             onChange={this.onChangeInventoryQuantity}
                                                             />
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    )
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="segment-note text-negative" style={{fontSize:"13px",margin:"20px auto 0 auto"}}>
                        Note. Click on apply to update the inventory or back to undo these changes
                    </div>

                    <div className="segment-buttons">
                        <div className="segment-error">{this.state.error}</div>
                        <Button onClick={()=>{this.setState({step:"estate",errror:""})}}>Back</Button>
                        <Button onClick={this.onApplyInventory}>Apply</Button>
                    </div>
                </Step>
            </AddListItem>
        )
    }
}
